import { render, staticRenderFns } from "./projectsOne.vue?vue&type=template&id=5ce4d1b2&scoped=true&"
import script from "./projectsOne.vue?vue&type=script&lang=js&"
export * from "./projectsOne.vue?vue&type=script&lang=js&"
import style0 from "./projectsOne.vue?vue&type=style&index=0&id=5ce4d1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4d1b2",
  null
  
)

export default component.exports